// Render layers for selective bloom (docs/ART-DIRECTION.md §2.5, §7). An object lives on exactly one
// layer: BASE is drawn as-is, EMISSIVE is drawn in the bloom pass and composited additively on top.

import type { Object3D } from 'three'

export const BASE_LAYER = 0
export const EMISSIVE_LAYER = 1

export type RenderLayer = typeof BASE_LAYER | typeof EMISSIVE_LAYER

export function assignLayer(object: Object3D, layer: RenderLayer): void {
  object.layers.set(layer)
}
